import { render, staticRenderFns } from "./leftTop.vue?vue&type=template&id=56a89067&scoped=true"
import script from "./leftTop.vue?vue&type=script&lang=js"
export * from "./leftTop.vue?vue&type=script&lang=js"
import style0 from "./leftTop.vue?vue&type=style&index=0&id=56a89067&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a89067",
  null
  
)

export default component.exports